var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHomeCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Home-4--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Home 4 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-4--home-house-roof-shelter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M7.693 0.917C7.3103 0.5343 6.6898 0.5343 6.307 0.917L0.427 6.797C0.0443 7.1797 0.0443 7.8002 0.427 8.183C0.8097 8.5657 1.4303 8.5657 1.813 8.183L2.1 7.8959V12.39C2.1 12.9313 2.5388 13.37 3.08 13.37H10.92C11.4613 13.37 11.9 12.9313 11.9 12.39V7.8959L12.1871 8.183C12.5697 8.5657 13.1903 8.5657 13.573 8.183C13.9557 7.8002 13.9557 7.1797 13.573 6.797L7.693 0.917Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHomeCurrent);
export default __webpack_public_path__ + "static/media/menu-home-current.acdd698753ec2b2f8522fe2bfdc0dca0.svg";
export { ForwardRef as ReactComponent };